import React from 'react';
import { Box } from '@mui/material';
import { Icon, IconProps } from '@ui/Icon';
import { CandidateRowStatus } from './candidate-status.helpers';
import AutoMappedStatusIcon from './icons/auto-mapped-status.svg?react';

type StatusMuiIcon = IconProps<'mui'>['icon'];

const STATUS_MUI_ICON: Record<
  Exclude<
    CandidateRowStatus,
    'autoMapped' | 'aiMapped' | 'discarded' | 'autoDiscarded'
  >,
  StatusMuiIcon
> = {
  mapped: 'Check',
  incomplete: 'WarningAmber',
};

const ROW_STATUS_ICON_SIZE_PX = 12;
const SIDEBAR_STATUS_ICON_SIZE_PX = 14;

export const STATUS_ICON_OUTER_SIZE_PX = ROW_STATUS_ICON_SIZE_PX;

const createStatusIcons = (
  sizePx: number,
): Record<CandidateRowStatus, React.ReactNode> => ({
  autoMapped: (
    <Box
      sx={{
        alignItems: 'center',
        color: 'inherit',
        display: 'inline-flex',
        height: sizePx,
        justifyContent: 'center',
        width: sizePx,
      }}
    >
      <AutoMappedStatusIcon height="100%" width="100%" />
    </Box>
  ),
  aiMapped: (
    <Box
      sx={{
        alignItems: 'center',
        color: 'inherit',
        display: 'inline-flex',
        height: sizePx,
        justifyContent: 'center',
        position: 'relative',
        width: sizePx,
      }}
    >
      <Icon category="mui" icon="Check" size={sizePx} />
      <Box
        sx={{
          alignItems: 'center',
          bottom: -3,
          display: 'flex',
          justifyContent: 'center',
          position: 'absolute',
          right: -4,
        }}
      >
        <Icon
          category="mui"
          icon="AutoAwesome"
          size={Math.max(8, sizePx - 2)}
        />
      </Box>
    </Box>
  ),
  mapped: <Icon category="mui" icon={STATUS_MUI_ICON.mapped} size={sizePx} />,
  incomplete: (
    <Icon category="mui" icon={STATUS_MUI_ICON.incomplete} size={sizePx} />
  ),
  discarded: <Icon category="ui" icon="toggleOff" size={sizePx} />,
  // AUTO-DISCARDED shares DISCARDED's icon + color; only the label differs.
  autoDiscarded: <Icon category="ui" icon="toggleOff" size={sizePx} />,
});

/** Status icons in import list rows and file-header status summary. */
export const STATUS_ICON = createStatusIcons(ROW_STATUS_ICON_SIZE_PX);

/** Status icons in import side panel legend. */
export const STATUS_ICON_SIDEBAR = createStatusIcons(
  SIDEBAR_STATUS_ICON_SIZE_PX,
);

export const STATUS_COLOR: Record<CandidateRowStatus, string> = {
  autoMapped: 'rgba(0,0,0,0.6)',
  aiMapped: 'rgba(0,0,0,0.6)',
  mapped: 'rgba(0,0,0,0.6)',
  incomplete: '#F6841A',
  discarded: 'rgba(0,0,0,0.3)',
  autoDiscarded: 'rgba(0,0,0,0.3)',
};
